import React                                from 'react';
import { TransitionGroup, CSSTransition }   from "react-transition-group";

class Helper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  };
    }

    renderHelperTexts() {
        let p = this.props;
        if(typeof p.text === 'object'){
            return p.text.map( (t, i) => {
                return (
                    <TransitionGroup key= { i + t } className="simprakit-dropdown-helper-wrapper">
                        <CSSTransition
                            appear      = { true }
                            unmountOnExit
                            classNames  = 'helper-transition'
                            timeout     = { 200 }
                            key         = { t } 
                        >                       
                            <span key={ t }>{ t }</span>
                        </CSSTransition> 
                    </TransitionGroup>
                );
            })
        }

        return (
            <TransitionGroup className="simprakit-dropdown-helper-wrapper">
                <CSSTransition
                    appear      = { true }
                    unmountOnExit
                    classNames  = 'helper-transition'
                    timeout     = { 200 }
                >  
                    <span>{ p.text }</span>
                </CSSTransition> 
            </TransitionGroup>
        );
    }
    render(){
        let p = this.props;
        return(
            <div className={ `simprakit-dropdown-helper${ p.isFocused ? ' focused' : '' }${ p.isDisabled ? ' disabled' : '' }` }>
                { this.renderHelperTexts() }
            </div>
        );
    }
}

export default Helper;